// Product Gallery Swiper - handles main image and thumbnail carousel sync
class SwiperProductGallery {
  constructor(element, options = {}) {
    this.element = element;
    this.options = options;
    this.mainSwiper = null;
    this.thumbSwiper = null;
    this.init();
    this.setupGallerySync();
  }

  init() {
    const mainSwiperEl = this.element.querySelector('.main-product-swiper');
    const thumbSwiperEl = this.element.querySelector('.thumbnail-swiper');

    if (mainSwiperEl) {
      this.initMainSwiper(mainSwiperEl);
    }

    if (thumbSwiperEl) {
      this.initThumbnailSwiper(thumbSwiperEl);
    }

    // Sync the two swipers
    this.syncSwipers();

    return this.mainSwiper;
  }

  initMainSwiper(swiperEl) {
    const config = {
      // Core settings
      loop: false,
      effect: 'slide',
      speed: 300,
      spaceBetween: 0,
      slidesPerView: 1,
      autoHeight: true, // Automatically adjust height to active slide
      navigation: false, // No navigation on main gallery
      pagination: false, // No pagination on main gallery

      // Accessibility
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide'
      },

      // Mobile offset for bleed effect (disabled for main gallery)
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,

      // Responsive breakpoints
      breakpoints: {
        750: {
          slidesPerView: 1,
          spaceBetween: 0,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          autoHeight: true // Ensure autoHeight works on desktop too
        }
      }
    };

    this.mainSwiper = new Swiper(swiperEl, config);
    swiperEl.swiperInstance = this.mainSwiper;
  }

  initThumbnailSwiper(swiperEl) {
    const spaceBetweenMobile = parseInt(swiperEl.dataset.spaceBetweenMobile) || 8;
    const slidesPerViewMobile = parseInt(swiperEl.dataset.slidesPerViewMobile) || 4;
    const spaceBetweenDesktop = parseInt(swiperEl.dataset.spaceBetweenDesktop) || 10;
    const slidesPerViewDesktop = parseInt(swiperEl.dataset.slidesPerViewDesktop) || 5;

    const config = {
      // Core settings
      loop: false,
      effect: 'slide',
      speed: 300,
      spaceBetween: spaceBetweenMobile,
      slidesPerView: slidesPerViewMobile,
      watchSlidesProgress: true,
      freeMode: true,

      // Navigation
      navigation: {
        nextEl: swiperEl.parentElement.querySelector('.swiper-button-next'),
        prevEl: swiperEl.parentElement.querySelector('.swiper-button-prev')
      },

      // Accessibility
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide'
      },

      // Mobile offset for bleed effect
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,

      // Responsive breakpoints for thumbnails
      breakpoints: {
        750: {
          slidesPerView: slidesPerViewDesktop,
          spaceBetween: spaceBetweenDesktop,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        }
      }
    };

    this.thumbSwiper = new Swiper(swiperEl, config);
    swiperEl.swiperInstance = this.thumbSwiper;
  }

  syncSwipers() {
    if (!this.mainSwiper || !this.thumbSwiper) return;

    // When thumbnail is clicked, update main gallery
    this.thumbSwiper.on('slideChange', () => {
      this.mainSwiper.slideTo(this.thumbSwiper.activeIndex);
    });

    // When main gallery changes, update thumbnail active state
    this.mainSwiper.on('slideChange', () => {
      this.thumbSwiper.slideTo(this.mainSwiper.activeIndex);
    });
  }

  setupGallerySync() {
    // Setup thumbnail click handlers
    setTimeout(() => {
      const thumbnailButtons = this.element.querySelectorAll('[data-target] button');

      thumbnailButtons.forEach((button, index) => {
        button.addEventListener('click', (e) => {
          // Update both Swiper instances
          if (this.mainSwiper) {
            this.mainSwiper.slideTo(index);
          }

          if (this.thumbSwiper) {
            this.thumbSwiper.slideTo(index);
          }
        });
      });
    }, 100);
  }

  // Cleanup
  destroy() {
    if (this.mainSwiper) {
      this.mainSwiper.destroy();
      this.mainSwiper = null;
    }
    if (this.thumbSwiper) {
      this.thumbSwiper.destroy();
      this.thumbSwiper = null;
    }
    super.destroy();
  }
}

// Export for use by other components
window.SwiperProductGallery = SwiperProductGallery;

// Initialize product gallery swipers when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  const productGalleryWrappers = document.querySelectorAll('.swiper-product-gallery-wrapper');

  productGalleryWrappers.forEach(wrapper => {
    new SwiperProductGallery(wrapper);
  });
});

document.addEventListener('shopify:section:load', function(event) {
  const productGalleryWrappers = event.target.querySelectorAll('.swiper-product-gallery-wrapper');
  productGalleryWrappers.forEach(wrapper => {
    new SwiperProductGallery(wrapper);
  });
});

document.addEventListener('shopify:section:unload', function(event) {
  const productGalleryWrappers = event.target.querySelectorAll('.swiper-product-gallery-wrapper');
  productGalleryWrappers.forEach(wrapper => {
    const mainSwiperEl = wrapper.querySelector('.main-product-swiper');
    const thumbSwiperEl = wrapper.querySelector('.thumbnail-swiper');

    if (mainSwiperEl && mainSwiperEl.swiperInstance) {
      mainSwiperEl.swiperInstance.destroy();
    }
    if (thumbSwiperEl && thumbSwiperEl.swiperInstance) {
      thumbSwiperEl.swiperInstance.destroy();
    }
  });
});